import { useState, useEffect } from 'react'
import './VideoModal.css'

const extractYouTubeId = (url) => {
    if (!url) return null
    const match = url.match(/(?:v=|youtu\.be\/|embed\/)([a-zA-Z0-9_-]{11})/)
    return match ? match[1] : null
}

const VideoModal = () => {
    const [show, setShow] = useState(false)
    const [videoId, setVideoId] = useState('')

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await fetch('/api/settings/videoModal')
                if (!res.ok) return

                const data = await res.json()
                if (!data.value) return

                const config = JSON.parse(data.value)
                if (!config.enabled || !config.videoUrl) return

                const id = extractYouTubeId(config.videoUrl)
                if (!id) return

                // Only show once per browser session (not on refresh)
                if (sessionStorage.getItem('videoModalShown')) return
                sessionStorage.setItem('videoModalShown', '1')

                setVideoId(id)
                const delay = parseInt(config.delay || 2500, 10)
                setTimeout(() => setShow(true), delay)
            } catch (e) {
                // silently fail — modal is optional
            }
        }

        fetchSettings()
    }, [])

    if (!show || !videoId) return null

    return (
        <div
            className="vmodal-overlay"
            onClick={() => setShow(false)}
            role="dialog"
            aria-modal="true"
            aria-label="Featured video"
        >
            <div className="vmodal-box" onClick={e => e.stopPropagation()}>
                <button
                    className="vmodal-close"
                    onClick={() => setShow(false)}
                    aria-label="Close video"
                >
                    <i className="fas fa-times"></i>
                </button>
                <div className="vmodal-embed">
                    <iframe
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
                        title="Featured Video"
                        allow="autoplay; encrypted-media; picture-in-picture"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    )
}

export default VideoModal
